module.exports = __webpack_public_path__ + "static/media/S20+_Cloudblue.e1431aed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/samsung-galaxy/s20+/S20+_Cloudblue.png
// module id = 2198
// module chunks = 0